import { toJson } from "kreate-common/modules/json-utils";

import { InfiniteResourceKey, ResourceKey } from "../types";

export function generateHttpGet<Params = never, Result = never>(
  parseResult: (data: unknown) => Result
) {
  return async function httpGet(url: string, params?: Partial<Params>) {
    if (params) {
      const search = new URLSearchParams();
      for (const [key, value] of Object.entries(params)) {
        if (value == null) continue;
        search.append(key, value.toString());
      }
      if (search.toString()) {
        url += "?" + search.toString();
      }
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("response not ok", {
        cause: {
          status: response.status,
          statusText: response.statusText,
          json: await response.json().catch(() => undefined),
        },
      });
    }

    const data = await response.json();
    return parseResult(data);
  };
}

export function generateHttpPost<Params = never, Result = never>(
  parseResult: (data: unknown) => Result
) {
  return async function httpPost(url: string, params?: Partial<Params>) {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: toJson(params),
    });

    if (!response.ok) {
      throw new Error("response not ok", {
        cause: {
          status: response.status,
          statusText: response.statusText,
          json: await response.json().catch(() => undefined),
        },
      });
    }

    const data = await response.json();
    return parseResult(data);
  };
}

export function generateGetResourceKey<Params = never>(path: ResourceKey) {
  return function getResourceKey(params: Params): ResourceKey {
    return [...path, params];
  };
}

export function generateGetInfiniteResourceKey<Params = never>(
  prefix: ResourceKey
) {
  return function getResourceKey(params: Params): InfiniteResourceKey<Params> {
    return { path: prefix, params };
  };
}
